import styled from "styled-components";

export const NotificationStyled = styled.div`
  .theme_standard {
  }

  .Toastify__toast-container {
    width: unset;
    min-width: 300px;
  }

  .Toastify__toast {
    background: #fff !important;
    color: #000 !important;
    border-radius: 8px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
    padding: 12px 16px !important;
    border-left: 8px solid transparent;
    display: flex !important;
    align-items: flex-start !important;
    min-height: 61px;
  }

  .Toastify__toast--success {
    border-left-color: #21a526 !important;
  }

  .Toastify__toast--error {
    border-left-color: #ec5e49 !important;
  }

  .Toastify__toast--info {
  }

  .Toastify__toast-body {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1; /* ดัน body กินพื้นที่เหลือ ให้ปุ่ม close ไปอยู่ขวาสุด */
    font-family: ${({ theme }) => theme.FONT.STYLE.MEDIUM};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    color: ${({ theme }) => theme.COLORS.BLACK_1};
  }
`;
